import { useState } from "react"

export const useFlashMessage = () => {
  const [flash, setFlash] = useState(null)

  const showMessage = ({ message, type = "info", mode = "auto" }) => {
    setFlash({ message, type, mode })
  }

  const hideMessage = () => {
    setFlash(null)
  }

  return {
    flash,
    showMessage,
    hideMessage,
  }
}
